import { useAppSelector } from '../../store/hooks'

function useAuth() {
    const { signedIn, token, isVerified } = useAppSelector((state) => state.auth)

    // Simple authenticated check - user is authenticated if they have a token and are signed in
    const authenticated = !!(token && signedIn)

    // For this app, we'll use a simple authFlow - 'completed' if authenticated
    const authFlow = authenticated ? 'completed' : 'pending'

    return {
        authenticated,
        authFlow,
        isVerified,
        token,
        signedIn,
    }
}

export default useAuth

